import React from 'react';
import '../template-file-css/document-file-template.css';



export const HFI_DiagnosticEvaluation = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='HFI_DiagnosticEvaluation' className='file-pdf-document'>
            <div className='file-template'>



                <p className='w-750'><center><h3>Diagnostic Evaluation</h3></center></p>

                {/* <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Person Served Name: </span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>Date</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPersonServedName' name='txtPersonServedName' className='add-only'/></td>
                        <td className='w-375'>
                            <input type='date' id='txtDate' name='txtDateBirth' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Start Time:</span></td>
                        <td className='w-375'>
                            <span className='eleHeader'>End Time:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='time' id='txtStartTime' name='txtStartTime' className='add-only'/></td>
                        <td className='w-375'>
                            <input type='time' id='txtEndTime' name='txtEndTime' className='add-only'/></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Service Code:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Units:</span></td>
                        <td className='w-250'>
                            <span className='eleHeader'>Place of Service:</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='text' id='txtServiceCode' name='txtServiceCode' className='add-only'/></td>
                        <td className='w-250'>
                            <input type='text' id='txtUnit' name='txtUnit' className='add-only'/></td>
                        <td className='w-250'>
                            <input type='text' id='txtPlaceOfService' name='txtPlaceOfService' className='add-only'/></td>
                    </tr>
                </table> */}

                <p className='w-750'>
                    <span className='eleHeader'>HISTORY OF PRESENTING PROBLEM (onset, duration, course)</span>
                    <span className='small'>(Why presenting now/precipitants/stressors? When it started? How long it lasts/frequency? What is it like? Impact on life)</span>
                    <textarea id='txtHistoryOfPresentingProblem' name='txtHistoryOfPresentingProblem' className='add-only'></textarea></p>

                <p className='w-750'><h4><b>SIGNS/SYMPTOMS/BEHAVIORS REVIEW</b></h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>DEPRESSION(“Sigecaps”)</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_1' name='cbDepression_1' className='add-only' value='Sleep'/> Sleep </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_2' name='cbDepression_2' className='add-only' value='Interest'/> Interest </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_3' name='cbDepression_3' className='add-only' value='GuiltWorthlessness'/> Guilt/Worthlessness </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_4' name='cbDepression_4' className='add-only' value='Energy'/> Energy </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_5' name='cbDepression_5' className='add-only' value='Concentration'/> Concentration </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_6' name='cbDepression_6' className='add-only' value='AppetiteWeight'/> Appetite/Weight </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_7' name='cbDepression_7' className='add-only' value='Psychomotor'/> Psychomotor </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbDepression_8' name='cbDepression_8' className='add-only' value='Suicide'/> Suicide: Hopelessness/Plan/Access</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>MANIA(“Giddiness”)</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_1' name='cbMania_1' className='add-only' value='Grandiose'/> Grandiose</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_2' name='cbMania_2' className='add-only' value='IncreaseActivity'/> Increase activity</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_3' name='cbMania_3' className='add-only' value='GoalRisk'/> Goal-directed/high risk</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_4' name='cbMania_4' className='add-only' value='Decreased'/> Decreased judgement</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_5' name='cbMania_5' className='add-only' value='Distractible'/> Distractible</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_6' name='cbMania_6' className='add-only' value='Irritability'/> Irritability</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_7' name='cbMania_7' className='add-only' value='NeedSleep'/> Need less sleep</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_8' name='cbMania_8' className='add-only' value='ElevatedMood'/> Elevated Mood</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_9' name='cbMania_9' className='add-only' value='SpeedyTalking'/> Speedy Talking</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbMania_10' name='cbMania_10' className='add-only' value='SpeedyThoughts'/> Speedy Thoughts</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PYSCHOSIS</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_1' name='cbPyschosis_1' className='add-only' value='Hallucinations/illusions'/> Hallucinations/illusions</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_2' name='cbPyschosis_2' className='add-only' value='Delusions'/> Delusions</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_3' name='cbPyschosis_3' className='add-only' value='SelfReference'/> Self-reference</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_4' name='cbPyschosis_4' className='add-only' value='PeopleWatching'/> People watching you</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_5' name='cbPyschosis_5' className='add-only' value='Talking'/> Talking to you</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_6' name='cbPyschosis_6' className='add-only' value='MessagesMedia'/> Messages from media</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_7' name='cbPyschosis_7' className='add-only' value='SpeechBehavior'/> Speech/behavior</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPyschosis_8' name='cbPyschosis_8' className='add-only' value='Disorganization'/> Disorganization</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbPyschosis_9' name='cbPyschosis_9' className='add-only' value='ThoughtBlockingInsertions'/> Thought blocking/insertions</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PANIC ATTACKS</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_1' name='cbPanicAttacks_1' className='add-only' value='Trembling'/> Trembling</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_2' name='cbPanicAttacks_2' className='add-only' value='Palpitations'/> Palpitations</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_3' name='cbPanicAttacks_3' className='add-only' value='NauseaChills'/> Nausea/chills</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_4' name='cbPanicAttacks_4' className='add-only' value='ChokingChestPain'/> Choking/chest pain</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_5' name='cbPanicAttacks_5' className='add-only' value='Sweating'/> Sweating</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_6' name='cbPanicAttacks_6' className='add-only' value='DizzyUnsteady'/> Dizzy/unsteady</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_7' name='cbPanicAttacks_7' className='add-only' value='Fear'/> Fear</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_8' name='cbPanicAttacks_8' className='add-only' value='DyingGoingCrazy'/> Dying/going crazy</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_9' name='cbPanicAttacks_9' className='add-only' value='AnticipatoryAnxiety'/> Anticipatory anxiety</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_10' name='cbPanicAttacks_10' className='add-only' value='Avoidance'/> Avoidance</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbPanicAttacks_11' name='cbPanicAttacks_11' className='add-only' value='Agoraphobia'/> Agoraphobia</td>
                        <td className='w-187'>&nbsp;</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>GENERALIZED ANXIETY</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGeneralizedAnxiety_1' name='cbGeneralizedAnxiety_1' className='add-only' value='ExcessWorry'/> Excess worry</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGeneralizedAnxiety_2' name='cbGeneralizedAnxiety_2' className='add-only' value='RestlessEdgy'/> Restless/edgy</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGeneralizedAnxiety_3' name='cbGeneralizedAnxiety_3' className='add-only' value='EasilyFatigued'/> Easily fatigued</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGeneralizedAnxiety_4' name='cbGeneralizedAnxiety_4' className='add-only' value='MuscleTension'/> Muscle tension</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGeneralizedAnxiety_5' name='cbGeneralizedAnxiety_5' className='add-only' value='Sleep'/> Sleep</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbGeneralizedAnxiety_6' name='cbGeneralizedAnxiety_6' className='add-only' value='Concentration'/> Concentration</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>OBSESSIVE COMPULSIVE DISORDER</span></td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessiveCompulsiveDisorder_1' name='cbObsessiveCompulsiveDisorder_1' className='add-only' value='Intrusive'/> Intrusive/persistent thoughts</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessiveCompulsiveDisorder_2' name='cbObsessiveCompulsiveDisorder_2' className='add-only' value='RecognizedAsExcessive'/> Recognized as excessive/irrational</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessiveCompulsiveDisorder_3' name='cbObsessiveCompulsiveDisorder_3' className='add-only' value='Repetitive'/> Repetitive behaviors</td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessiveCompulsiveDisorder_4' name='cbObsessiveCompulsiveDisorder_4' className='add-only' value='Washing'/> Washing/cleaning</td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessiveCompulsiveDisorder_5' name='cbObsessiveCompulsiveDisorder_5' className='add-only' value='CountingChecking'/> Counting/checking </td>
                        <td className='w-187'>
                            <input type='checkbox' id='cbObsessiveCompulsiveDisorder_6' name='cbObsessiveCompulsiveDisorder_6' className='add-only' value='OrganizingPraying'/> Organizing/praying</td>
                        <td className='w-187'>&nbsp;</td>
                        <td className='w-187'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PTSD</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_1' name='cbPtsd_1' className='add-only' value='ExperiencedWitnessEvent'/> Experienced/witness event</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_2' name='cbPtsd_2' className='add-only' value='PersistentExperiencing'/> Persistent Re-experiencing</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_3' name='cbPtsd_3' className='add-only' value='Dreams'/> Dreams/flashbacks</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_4' name='cbPtsd_4' className='add-only' value='Avoidance'/> Avoidance behavior</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_5' name='cbPtsd_5' className='add-only' value='HyperArousal'/> Hyper-arousal</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_6' name='cbPtsd_6' className='add-only' value='Vigilance'/> Vigilance</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbPtsd_7' name='cbPtsd_7' className='add-only' value='Startle'/> Startle</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SOCIAL PHOBIA</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSocialPhobia_1' name='cbSocialPhobia_1' className='add-only' value='Performance'/> Performance situations</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSocialPhobia_2' name='cbSocialPhobia_2' className='add-only' value='FearEmbarrassment'/> Fear of embarrassment</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSocialPhobia_3' name='cbSocialPhobia_3' className='add-only' value='FearHumiliation'/> Fear of humiliation</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbSocialPhobia_4' name='cbSocialPhobia_4' className='add-only' value='Criticism'/> Criticism</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SPECIFIC PHOBIA</span></td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' id='cbSocialPhobia_1' name='cbSocialPhobia_1' className='add-only' value='HeightsCrowds'/> Heights/crowds/animals</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>BORDERLINE PERSONALITY</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_1' name='cbBorderlinePersonality_1' className='add-only' value='FearAbandoment'/> Fear abandonment/rejection</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_2' name='cbBorderlinePersonality_2' className='add-only' value='UnstableRelationships'/> Unstable relationships</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_3' name='cbBorderlinePersonality_3' className='add-only' value='ChronicEmptiness'/> Chronic emptiness</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_4' name='cbBorderlinePersonality_4' className='add-only' value='SelfEsteem'/> self esteem</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_5' name='cbBorderlinePersonality_5' className='add-only' value='IntenseAngerOutbursts'/> Intense anger/outbursts</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_6' name='cbBorderlinePersonality_6' className='add-only' value='SelfDamaging'/> Self-damaging behavior</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBorderlinePersonality_7' name='cbBorderlinePersonality_7' className='add-only' value='LabileMoodAndImpulsivity'/> Labile mood and impulsivity</td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ANTISOCIAL PERSONALITY</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAntisocialPersonality_1' name='cbAntisocialPersonality_1' className='add-only' value='ChildhoodConductDisorder'/> Childhood conduct disorder </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAntisocialPersonality_2' name='cbAntisocialPersonality_2' className='add-only' value='AggressivenessViolence'/> Aggressiveness/violence</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAntisocialPersonality_3' name='cbAntisocialPersonality_3' className='add-only' value='LackEmpathy'/> Lack of empathy/remorse</td>

                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAntisocialPersonality_4' name='cbAntisocialPersonality_4' className='add-only' value='LackOfConcern'/> Lack of concern for safety: self or others</td>
                        <td className='w-375'>
                            <input type='checkbox' id='cbAntisocialPersonality_5' name='cbAntisocialPersonality_5' className='add-only' value='ForensicHistory'/> Forensic history:Arrests/imprisonment</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>BODY DSYMOPRHIC DISORDER</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbBodyDsymophicDisorder_1' name='cbBodyDsymophicDisorder_1' className='add-only' value='ExcessConcern'/> Excess concern with appearance or certain part of body</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbBodyDsymophicDisorder_2' name='cbBodyDsymophicDisorder_2' className='add-only' value='AvoidanceBehavior'/> Avoidance behavior</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>EATING DISORDER</span></td>
                    </tr>
                    <tr>
                        <td className='w-500'>
                            <input type='checkbox' id='cbEatingDisorder_1' name='cbEatingDisorder_1' className='add-only' value='BingingPurging'/> Binging/purging/restriction/amenorrhea </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbEatingDisorder_2' name='cbEatingDisorder_2' className='add-only' value='PerceptionBody'/> Perception of body image or weight</td>
                    </tr>

                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>DISRUPTIVE/IMPULSE/CONDUCT</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_1' name='cbDisruptiveImpulseConduct_1' className='add-only' value='AngryIrritableMood'/> Angry/irritable mood</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_2' name='cbDisruptiveImpulseConduct_2' className='add-only' value='ArgumentativeDefiant'/> Argumentative/Defiant</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_3' name='cbDisruptiveImpulseConduct_3' className='add-only' value='SpitefulOrVindictive'/> Spiteful or vindictive</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_4' name='cbDisruptiveImpulseConduct_4' className='add-only' value='ExplosiveAggressive'/> Explosive/aggressive</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_5' name='cbDisruptiveImpulseConduct_5' className='add-only' value='AggressionToPeople'/> Aggression to people/animals</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_6' name='cbDisruptiveImpulseConduct_6' className='add-only' value='DestructionProperty'/> Destruction of property</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_7' name='cbDisruptiveImpulseConduct_7' className='add-only' value='DeceitfulnessOrTheft'/> Deceitfulness or theft</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_8' name='cbDisruptiveImpulseConduct_8' className='add-only' value='ServiousViolationsRules'/> Serious violations of rules</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbDisruptiveImpulseConduct_9' name='cbDisruptiveImpulseConduct_9' className='add-only' value='FireSetting'/> Fire Setting </td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>ADDICTIONS</span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_1' name='cbAddictions_1' className='add-only' value='Alcohol'/> Alcohol</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_2' name='cbAddictions_2' className='add-only' value='Caffeine'/> Caffeine</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_3' name='cbAddictions_3' className='add-only' value='Cannabis'/> Cannabis</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_4' name='cbAddictions_4' className='add-only' value='Hallucinogen'/> Hallucinogen</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_5' name='cbAddictions_5' className='add-only' value='Inhalant'/> Inhalant</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_6' name='cbAddictions_6' className='add-only' value='Opioids'/> Opioids</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_7' name='cbAddictions_7' className='add-only' value='Sedative'/> Sedative, hypnotic anxiolytic</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_8' name='cbAddictions_8' className='add-only' value='Stimulant'/> Stimulant</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_9' name='cbAddictions_9' className='add-only' value='Tabocco'/> Tobacco </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_10' name='cbAddictions_10' className='add-only' value='ClubDrugs'/> Club drugs</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbAddictions_11' name='cbAddictions_11' className='add-only' value='Gambling'/> Gambling</td>
                        <td className='w-250'>&nbsp;</td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>NEURODEVELOPMENT </span></td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_1' name='cbNeuroDevelopment_1' className='add-only' value='Inattention'/> Inattention</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_2' name='cbNeuroDevelopment_2' className='add-only' value='Hyperactivity'/> Hyperactivity </td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_3' name='cbNeuroDevelopment_3' className='add-only' value='Impulsivity'/> Impulsivity</td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_4' name='cbNeuroDevelopment_4' className='add-only' value='UnusualCommunication'/> Unusual Communication patterns</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_5' name='cbNeuroDevelopment_5' className='add-only' value='LearningImpairments'/> Learning impairments</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_6' name='cbNeuroDevelopment_6' className='add-only' value='Developmental'/> Developmental Coordination </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_7' name='cbNeuroDevelopment_7' className='add-only' value='SocialInterest'/> Social interest</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_8' name='cbNeuroDevelopment_8' className='add-only' value='OddPlayPatterns'/> Odd play patterns</td>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_9' name='cbNeuroDevelopment_9' className='add-only' value='RigidAdherenceTo'/> Rigid adherence to routines </td>

                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='checkbox' id='cbNeuroDevelopment_10' name='cbNeuroDevelopment_10' className='add-only' value='RepetitiveBehaviors'/> Repetitive behaviors </td>
                        <td className='w-250'>&nbsp;</td>
                        <td className='w-250'>&nbsp;</td>

                    </tr>
                </table>

                <p className='w-750'><h4>PSYCHIATRC HISTORY</h4>
                    <span className='eleHeader'>Previous Psychiatric Hx/Counseling/Suicide attempts/Violence:</span>
                    <textarea id='txtPreviousPsychiatric' name='txtPreviousPsychiatric' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Previous Diagnoses:</span>
                    <textarea id='txtPreviousPsychiatric' name='txtPreviousPsychiatric' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Medications/Tx:</span>
                    <textarea id='txtMedications' name='txtMedications' className='add-only'></textarea>
                </p>


                <p className='w-750'><h4>FAMILY PSYCHIATRIC HISTORY</h4>
                    <span className='eleHeader'>Psychiatric Dx/Visits/Counseling/Suicide attempts:</span>
                    <textarea id='txtPsychiatricVisits' name='txtPsychiatricVisits' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Substance/Alcohol Use: </span>
                    <textarea id='txtSubstanceAlcohol' name='txtSubstanceAlcohol' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Suicide:</span>
                    <textarea id='txtSuicide' name='txtSuicide' className='add-only'></textarea>
                </p>



                <p className='w-750'><h4>MEDICAL HISTORY </h4>
                    <span className='eleHeader'>Previous Illness & Treatment:</span>
                    <textarea id='txtPreviousIllness' name='txtPreviousIllness' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Surgeries/Hospitalizations: (obstetric history)</span>
                    <textarea id='txtSurgeriesHospitalizations' name='txtSurgeriesHospitalizations' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>Head injury (+/- LOC) and workup/imaging</span>
                    <textarea id='txtHeadInjury' name='txtHeadInjury' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Medications:(birth control)</span>
                    <textarea id='txtMedicationsBirthControl' name='txtMedicationsBirthControl' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Alcohol Use:</span>
                    <textarea id='txtAlcoholUse' name='txtAlcoholUse' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>Substance Use: (caffeine, nicotine, over counter/illicit med/drugs)</span>
                    <textarea id='txtSubstanceUseCaffeine' name='txtSubstanceUseCaffeine' className='add-only'></textarea>
                </p>



                <p className='w-750'><h4>PERSONAL HISTORY </h4>
                    <span className='eleHeader'>Place of Birth:</span>
                    <input type='text' id='txtPlaceOfBirth' name='txtPlaceOfBirth' className='add-only'/></p>

                <p className='w-750'><span className='eleHeader'>As a child: (family structure, parent's occupations, relationship with parents, siblings, friends, abuse)</span>
                    <textarea id='txtAsAchildFamily' name='txtAsAchildFamily' className='add-only'></textarea></p>

                <p className='w-750'><span className='eleHeader'>As a teen: (friends, relationships, school, activities, sex, trouble, relationship with parents)</span>
                    <textarea id='txtAsATeenFriendsRelationships' name='txtAsATeenFriendsRelationships' className='add-only'></textarea>
                </p>




                <p className='w-750'><span className='eleHeader'>IMPRESSION/FORMULATION</span>
                    <textarea id='txtImpressionFormulation' name='txtImpressionFormulation' className='add-only'></textarea>
                </p>

                <p className='w-750'><span className='eleHeader'>DIAGNOSIS</span>
                    <textarea id='txtDiagnosis' name='txtDiagnosis' className='add-only'></textarea>
                </p>

                {/* <p className='w-750'><span className='eleHeader'>PLAN</span>
                    <textarea id='txtPlan' name='txtPlan' className='add-only'></textarea>
                </p>

                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Appropriately Licensed Practitioner & Credentials</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;</td>
                        <td className='signature w-250'>&nbsp;</td>
                    </tr>
                    <tr>
                        <td className='small w-500'>Signature of Appropriately Licensed Practitioner & Credentials</td>
                        <td className='small w-250'>Date</td>
                    </tr>
                </table> */}






















            </div>
        </form>

    )
}  
